const index = ({ valor, func, name, tipo = 'text', inputMode, maxLength = '30', required = true }) => {
	return (
		<div className="input-criacao-usuario margin-vertical-30">
			<label className="titulo-input-criacao">{name}:</label>
			<input
				required={required}
				onChange={(c) => func(c.target.value)}
				type={tipo}
				inputMode={inputMode}
				maxLength={maxLength}
				className="form-control input-dados-criar"
				value={valor || ''}
			/>
		</div>
	);
};

export default index;
